// eslint-disable-next-line no-unused-vars
import React from 'react';
import { AppRegistry } from 'react-native';
import { Provider } from 'react-redux';
// import firebase from 'firebase/app';
import 'firebase/analytics';
// import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';

import App from './App';
import './index.css';
import store from './store/store';

// const firebaseConfig = {
//   apiKey: 'AIzaSyChX5uEtwvPT3dtzJioO7SaI9slEr8arso',
//   authDomain: 'zonetail-home.firebaseapp.com',
//   projectId: 'zonetail-home',
//   storageBucket: 'zonetail-home.appspot.com',
//   messagingSenderId: '612214356838',
//   appId: '1:612214356838:web:3bba4a33bb7cd0db29a6a7',
//   measurementId: 'G-Y24RJHNQ9F',
// };

// // const app = initializeApp(firebaseConfig);
// // const analytics = getAnalytics(app);

// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

import iconAntFont from 'react-native-vector-icons/Fonts/AntDesign.ttf';
const iconAntStyles = `@font-face {
  src: url(${iconAntFont});
  font-family: AntDesign;
}`;

const styleAnt = document.createElement('style');
styleAnt.type = 'text/css';
if (styleAnt.styleSheet) {
  styleAnt.styleSheet.cssText = iconAntStyles;
} else {
  styleAnt.appendChild(document.createTextNode(iconAntStyles));
}
document.head.appendChild(styleAnt);

import iconFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: FontAwesome;
}`;

const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}
document.head.appendChild(style);

import iconMaterialFont from 'react-native-vector-icons/Fonts/MaterialIcons.ttf';
const iconMaterialFontStyles = `@font-face {
  src: url(${iconMaterialFont});
  font-family: MaterialIcons;
}`;
const styleMaterial = document.createElement('style');
styleMaterial.type = 'text/css';
if (styleMaterial.styleSheet) {
  styleMaterial.styleSheet.cssText = iconMaterialFontStyles;
} else {
  styleMaterial.appendChild(document.createTextNode(iconMaterialFontStyles));
}
document.head.appendChild(styleMaterial);

import iconEntypoFont from 'react-native-vector-icons/Fonts/Entypo.ttf';
const iconEntypoFontStyles = `@font-face {
  src: url(${iconEntypoFont});
  font-family: MaterialIcons;
}`;
const styleEntypo = document.createElement('style');
styleEntypo.type = 'text/css';
if (styleEntypo.styleSheet) {
  styleEntypo.styleSheet.cssText = iconMaterialFontStyles;
} else {
  styleEntypo.appendChild(document.createTextNode(iconEntypoFontStyles));
}
document.head.appendChild(styleEntypo);

import IoniconsFont from 'react-native-vector-icons/Fonts/Ionicons.ttf';
const ioniconsFontStyles = `@font-face {
  src: url(${IoniconsFont});
  font-family: Ionicons;
}`;

const styleIonIcons = document.createElement('style');
styleIonIcons.type = 'text/css';
if (styleMaterial.styleSheet) {
  styleIonIcons.styleSheet.cssText = ioniconsFontStyles;
} else {
  styleIonIcons.appendChild(document.createTextNode(ioniconsFontStyles));
}
document.head.appendChild(styleIonIcons);

// import FontAwesome_ttf from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
// import Entypo_ttf from 'react-native-vector-icons/Fonts/Entypo.ttf';
// import AntDesign_ttf from 'react-native-vector-icons/Fonts/Entypo.ttf';

// const IconsCSS = `
// @font-face {
//   src: url(${FontAwesome_ttf});
//   font-family: FontAwesome;
// }
// @font-face {
//   src: url(${Entypo_ttf});
//   font-family: Entypo;
// }
// `;

// const style = document.createElement('style');
// style.type = 'text/css';
// if (style.styleSheet) {
//   style.styleSheet.cssText = IconsCSS;
// } else {
//   style.appendChild(document.createTextNode(IconsCSS));
// }

// document.head.appendChild(style);

const Wrapper = () => {
  return (
    <Provider store={store.store}>
      <App />
    </Provider>
  );
};

AppRegistry.registerComponent('appName', () => Wrapper);

AppRegistry.runApplication('appName', {
  rootTag: document.getElementById('root'),
});
